import React from "react";
import keycode from "keycode";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import {Request} from "@codeArt/request";
import DataBase, {updateArray} from "../Base";

import {fetchError} from "redux/actions";
import _ from "lodash";
import {Footer} from "./footer";
import {Header} from "./header";
import {Empty} from "./empty";
import {Loading} from "./loading";
import {Repeater} from "./repeater";
import {Scrollbar} from "../../Scrollbar";
import {List} from "./list";
import {getColumns, getFixedWidth} from "./util";
import {Group} from "./group";
import { empty, type } from "@codeArt/utils/common";

let DataTableToolbar = props => {
  const {numSelected, title} = props;
  if (!title) return null;
  return (
    <Toolbar className="table-header">
      <div className="title">
        <Typography variant="h6">{title}</Typography>
      </div>
    </Toolbar>
  );
};

export default class DataTable extends DataBase {
  handleRequestSort = (event, property) => {};
  handleSelectAllClick = (event, checked) => {
    let {onAllRowSelected} = this.props;
    if (this.radio()) {
      this.setState({selected: []}, () => {
        if (onAllRowSelected) onAllRowSelected([]);
      });
      return;
    }

    let {rows, selected} = this.state;
    let my = this;
    if (checked) {
      rows.forEach(row => {
        if(my._getRowDisabled(row)) return;
        let key = my.getRowKey(row);
        if (!my.isSelected(key)) {
          selected = my.addOrRemove(selected, key);
        }
      });
    } else {
      rows.forEach(row => {
        if(my._getRowDisabled(row)) return;
        let key = my.getRowKey(row);
        if (my.isSelected(key)) {
          selected = my.addOrRemove(selected, key);
        }
      });
    }
    this.setState({selected}, () => {
      if (onAllRowSelected) onAllRowSelected(selected);
    });
  };
  handleKeyDown = (event, key) => {
    if (keycode(event) === "space") {
      this.handleRowClick(event, key);
    }
  };

  handleChangePage = (event, page) => {
    this.setState({pageIndex: page}, () => {
      this.load();
    });
  };
  handleChangeRowsPerPage = event => {
    this.setState({pageSize: event.target.value, pageIndex: 1}, () => {
      this.load();
    });
  };

  reload(p) {
    p = p || {};
    let {type, item, position} = p;
    if (type === "update") {
      let {selected, rows} = this.state;
      this.updateArray(rows, item);
      this.syncSelect(rows);
      this.setState({selected,rows});
    } else if (type === "delete") {
      let {selected} = this.state;
      this.deleteArray(selected, item);
      this.setState({selected}, () => {
        //刷新当前页
        this.load();
      });
    } else {
      //刷新当前页
      this.load();
    }
  }

  load(p) {
    p = p || {};
    let {action, data} = this.props;
    let {pageIndex} = this.state;
    let arg = this.getParams();
    arg.pageIndex = pageIndex;
    let pageSize = this.getPageSize();
    if(pageSize ) arg.pageSize = pageSize;

    let my = this;

    this.setState(
      {
        loading: true
      },
      () => {
        if(type(action)==="function"){
          action(arg,(r)=>{
            my.success(r, p);
          });
          return;
        }

        if(data){
          let r = this.getData();
          my.success(r, p);
          return;
        }

        Request(
          {
            url: action,
            data: arg,
            before: () => {},
            complete: () => {},
            success: r => {
              my.success(r, p);
            },
            error: (msg, dispatch) => {
              dispatch(fetchError(msg));
            }
          },
          this.props.dispatch
        );
      }
    );
  }

  getData() {
    let {data} = this.props;
    if(type(data)==="function") data=data();
    if (data) {
      let r = null;
      if (data.rows) {
        r = {
          rows: data.rows,
          pageIndex: 1,
          pageCount: 1,
          dataCount: data.rows.length,
          ...data
        };
      } else {
        r = {rows: data, pageIndex: 1, pageCount: 1, dataCount: data.length};
      }
      return r;
    } else {
      let {rows, pageIndex, pageCount, dataCount} = this.state;
      return {rows, pageIndex, pageCount, dataCount};
    }
  }

  getPageSize() {
    if(!this.props.page) return;
    return this.state.pageSize || this.props.pageSize;
  }

  success(r, p) {

    if (this.isUnmounted()) return;

    if (empty(r)) r = { pageCount: 0, rows: [], pageIndex: 0 };

    const { dataReceived, page } = this.props;

    if (dataReceived) {
      dataReceived(r, (result) => {
        this.loadComplete(page, result || r, p);
      });
    }
    else
      this.loadComplete(page, r, p);

  }

  loadComplete(page, r, p) {
    if (page) {
      let pageIndex = r.pageIndex; //归位pageIndex
      let needLoad = false;
      if (pageIndex > r.pageCount && r.pageCount !== 0) {
        //页码出错，校正页码后重新加载
        pageIndex = r.pageCount;
        needLoad = true;
      }

      let rows = r.rows || r.data;
      this.syncSelect(rows);
      this.setState(
        {
          pageIndex,
          rows,
          loading: false,
          pageCount: r.pageCount,
          dataCount: r.dataCount
        },
        () => {
          if (needLoad) this.load(p);
        }
      );
    } else {
      let rows = r.rows || r.data;
      this.syncSelect(rows);
      //非翻页模式
      this.setState({
        rows,
        loading: false,
        dataCount: r.dataCount
      });
    }
  }

  syncSelect(rows) {
    //由于数据可能被修改，所以需要从最新的数据中同步下selected的数据
    if (!rows || rows.length === 0) return;
    let my = this;
    let selected = this.state.selected;
    for (let i = 0; i < selected.length; i++) {
      let current = selected[i];
      let row = _.find(rows, row => my.getRowKey(row).value === current.value);
      if (row) selected[i] = my.getRowKey(row);
    }
    this.setState({selected});
  }

  constructor(props, context) {
    super(props, context);

    let data = this.state;
    this.state = {
      order: "asc",
      // orderBy: 'calories',
      rows: [],
      loading: true,
      pageIndex: 1,
      pageCount: 0,
      dataCount: 0,
      ...data
    };
  }

  componentWillMount() {
    super.componentWillMount();
  }

  columns(){
    return getColumns(this.props.columns);
  }

  getColumnLength() {
    let columns = this.columns();
    let count = columns.length;
    if (this.checkbox() || this.radio()) count++;
    return count;
  }

  renderEmpty() {
    let {emptyText, emptyComponent} = this.props;
    return <Empty emptyText={emptyText} emptyComponent={emptyComponent} />;
  }

  renderLoading() {
    return <Loading />;
  }

  renderHeader({loading, empty, fixedWidth}) {
    if (loading || empty) return null;

    const {order, rows, headerOffset} = this.state;
    let {
      headers,
      headerDisablePadding,
      headerClassName,
      go
    } = this.props;

    let columns = this.columns();

    let numSelected = rows.filter(row => this.isSelected(this.getRowKey(row)))
      .length;

      let my = this;

    return (
      <Header
        width={fixedWidth}
        offset={headerOffset}
        order={order}
        rows={rows}
        columns={columns}
        headers={headers}
        getRowDisabled={(row)=> my._getRowDisabled(row)}
        headerDisablePadding={headerDisablePadding}
        headerClassName={headerClassName}
        go={go}
        radioName={this.radioName}
        numSelected={numSelected}
        /*  isSelected={this.isSelected}
         getRowKey={row => {
           return this.getRowKey(row);
         }} */
        handleSelectAllClick={this.handleSelectAllClick}
        handleRequestSort={this.handleRequestSort}
        checkbox={this.checkbox()}
        radio={this.radio()}
      />
    );
  }

  renderFooter({loading, empty}) {
    if (loading || empty) return null;

    const {selected, rows, pageIndex, dataCount, pageCount} = this.state;
    let {page, repeater} = this.props;
    let pageSize = this.getPageSize();

    return (
      <Footer
        selected={selected}
        rows={rows}
        pageIndex={pageIndex}
        dataCount={dataCount}
        pageCount={pageCount}
        page={page}
        repeater={repeater}
        pageSize={pageSize}
        handleChangePage={this.handleChangePage}
        handleChangeRowsPerPage={this.handleChangeRowsPerPage}
      />
    );
  }

  renderMain({fixedWidth}) {
    let {repeater, renderItem} = this.props;

    if (repeater) {
      let {rows} = this.state;
      let {gap, layout} = repeater;
      return (
        <Repeater
          rows={rows}
          gap={gap}
          layout={layout}
          renderItem={renderItem}
        />
      );
    }

    let {onRowSelect, separator, rowHover, go} = this.props;
    let columns = this.columns();
    let {rows, selected} = this.state;
    let radioName = this.radioName;
    let checkbox = this.checkbox();
    let radio = this.radio();

    return (
      <List
        selected={selected}
        width={fixedWidth}
        columns={columns}
        onRowSelect={onRowSelect}
        separator={separator}
        rowHover={rowHover}
        go={go}
        rows={rows}
        radioName={radioName}
        checkbox={checkbox}
        radio={radio}
        handleRowClick={this.handleRowClick}
        handleKeyDown={this.handleKeyDown}
        handleTargetClick={this.handleTargetClick}
        getRowDisabled={this.props.getRowDisabled}
        getRowKey={row => {
          return this.getRowKey(row);
        }}
        isSelected={this.isSelected}
      />
    );
  }

  getState() {
    return {pageIndex: this.state.pageIndex};
  }

  acceptState(data) {
    this.setState(...data);
  }

  handleScroll(e) {
    let left = this.scrollbar.getScrollLeft();
    if (this.__headerOffset !== left) {
      this.setState({headerOffset: left});
      this.__headerOffset = left;
    }
  }

  tryScrollable(fixedWidth, content) {
    let {scrollable} = this.props;
    return scrollable ? (
      <div className="d-flex c-flex-1">
        <Scrollbar
          // autoHide={false} //目前设置这个有BUG，不需要滚动条的时候也会显示滚动条
          horizontal={Boolean(fixedWidth)}
          ref={r => {
            this.scrollbar = r;
          }}
          onScroll={e => {
            this.handleScroll(e);
          }}
        >
          {content}
        </Scrollbar>
      </div>
    ) : (
      content
    );
  }

  renderBody() {
    const {loading} = this.state;
    let columns = this.columns();
    let fixedWidth = getFixedWidth(columns);

    let content = null;
    let empty = this.isEmpty();
    if (loading) content = this.renderLoading();
    else if (empty) content = this.renderEmpty();
    else {
      content = this.tryScrollable(fixedWidth, this.renderMain({fixedWidth}));
    }

    return (
      <div className="d-flex flex-column c-flex-1">
        {this.renderHeader({loading, empty, fixedWidth})}
        {content}
        {this.renderFooter({loading, empty})}
      </div>
    );
  }

  renderGroup() {
    let {group} = this.props;
    return (
      <div className="d-flex flex-row h-100">
        <div className="d-flex flex-column h-100">
          <Group
            ref={r => {
              this.group = r;
            }}
            {...group}
          />
        </div>
        <div className="d-flex flex-column c-flex-1 h-100">
          {group.top?<div className={`d-flex flex-column ${this.isEmpty()||this.state.loading?'c-lb':''}`}>{group.top}</div>:null}
          {this.renderBody()}
        </div>
      </div>
    );
  }

  validGroup() {
    let {group} = this.props;
    return group && group.items && group.items.length > 0;
  }

  isEmpty(){
    const {dataCount, rows} = this.state;
    let {page} = this.props;
    return page ? dataCount === 0 : rows.length === 0;
  }

  render() {
    const {selected, dataCount, rows, loading} = this.state;
    let {
      title,
      toolbar,
      page,
      className,
      flat,
      scrollable,
      group,
      nowrap
    } = this.props;
    return (
      <Paper
        elevation={0}
        className={`c-dataGrid c-datatable ${nowrap
          ? "c-datatable-nowrap"
          : ""} ${flat ? "c-flat" : ""} d-flex flex-column ${scrollable
          ? "h-100"
          : ""} ${className}`}
      >
        <div className="d-flex flex-column h-100">
          <div className="d-flex flex-column">
            {title ? <DataTableToolbar title={title} /> : null}
            {toolbar}
          </div>
          {this.validGroup() ? this.renderGroup() : this.renderBody()}
        </div>
      </Paper>
    );
  }
}

DataTable.defaultProps = {
  className: "",
  pageSize: 10,
  emptyText: "暂无数据",
  page: true,
  rowSelect: true,
  rowHover: true,
  headerClassName: ""
};
